import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { CountryPhoneCodeDetails } from '../../../../../../UI/src/app/shared/phone-numbers/phone-number.service';

@Component({
  selector: 'sts-country-code',
  templateUrl: './country-code.component.html'
})
export class CountryCodeComponent implements OnInit, AfterViewInit {
  @Input() data: number;
  public searchInput = '';
  public countryPhoneCodes = [];

  constructor(
    public viewCtrl: ViewController,
    private countryPhoneCodeDetails: CountryPhoneCodeDetails
  ) { }

  ngOnInit() {
    this.countryPhoneCodes = this.countryPhoneCodeDetails.countryPhoneCodes;
  }

  ngAfterViewInit(){
    let elm = <HTMLInputElement>document.querySelector('#countrySearchBar input');
    if(elm)
      elm.focus();
  }

  getItems(input) {
    const searchStr = this.searchInput.toLowerCase();
    if (searchStr === "") {
      this.ngOnInit();
    } else {
      this.countryPhoneCodes = this.countryPhoneCodeDetails.countryPhoneCodes.filter(function (dt) {
        return (dt.countryName.toLowerCase().indexOf(searchStr) == 0);
      })
    }
  }

  selectItem(item) {
    this.viewCtrl.dismiss(item);
  }
}


// WEBPACK FOOTER //
// ./src/app/lib/phone-input/country-code/country-code.component.ts